import React, { FC, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { MessagePayedResourceDialog } from './message-dialog'

type PaidRouteGuardProps = {
    children: React.ReactNode
    isFree: boolean
}

const PaidRouteGuard: FC<PaidRouteGuardProps> = ({ children, isFree }) => {
    const [redirectTo, setRedirectTo] = useState<string | null>(null)

    if (!isFree) {
        return <>{children}</>
    }

    if (redirectTo) {
        return <Navigate to={redirectTo} replace />
    }

    return (
        <MessagePayedResourceDialog
            open={true}
            onClose={() => setRedirectTo('/dashboard/app')}
            onConfirm={() => setRedirectTo('/dashboard/pricing')}
        />
    )
}

export default PaidRouteGuard
